import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import CampaignMessageChatItem from "../Campaign/CampaignMessageChatItem";

const StreamNotifications = ({
  auth: { user, isAuthenticated },
  messages,
  message,
  deleteMessage,
  setShowNotifications,
  filterTextNotifications,
  setFilterTextNotifications,
  profile,
  TimeOut,
  setShowReportUser,
  setReportedUser,
  moderators,
  moderate,
  deleteModerator,
  timeoutDeleteMessage,
  banDeleteMessage,
  Ban,
  notifications,
  setNotifications,
}) => {
  const [xFalse, setXFalse] = useState(true);

  return (
    <Fragment>
      <div className="live-stream-side-container border-left grey">
        <div className="container-name">
          <i
            className="far fa-window-close fa-2x red close-window"
            onClick={() => setShowNotifications(false)}
          ></i>
          <p className="container-title cursor red">
            <i className="fa-solid fa-bell-concierge red mr-5"></i>Notifications
          </p>
          <i className="fas fa-external-link-alt fa-lg red pop-out"></i>
        </div>
        <div className="chat-search">
          <input
            type="text"
            className="gif-input"
            name="text"
            value={filterTextNotifications}
            onChange={(e) => setFilterTextNotifications(e.target.value)}
            placeholder="Search for notifications..."
          />
          <i className="fas fa-search magnifying red fa-lg cursor"></i>
        </div>
        <div className="all-content">
          {filterTextNotifications !== ""
            ? notifications
                .filter((message) => {
                  return (
                    message.firstname
                      .toLowerCase()
                      .match(filterTextNotifications) ||
                    message.text.toLowerCase().match(filterTextNotifications) ||
                    message.firstname.match(filterTextNotifications) ||
                    message.text.match(filterTextNotifications)
                  );
                })
                .map((message, index) => {
                  return (
                    <CampaignMessageChatItem
                      key={index}
                      user={user}
                      message={message}
                      messages={messages}
                      deleteMessage={deleteMessage}
                      isAuthenticated={isAuthenticated}
                      profile={profile}
                      TimeOut={TimeOut}
                      setShowReportUser={setShowReportUser}
                      setReportedUser={setReportedUser}
                      moderators={moderators}
                      moderate={moderate}
                      deleteModerator={deleteModerator}
                      timeoutDeleteMessage={timeoutDeleteMessage}
                      banDeleteMessage={banDeleteMessage}
                      Ban={Ban}
                      notifications={notifications}
                      setNotifications={setNotifications}
                      xFalse={xFalse}
                    />
                  );
                })
            : notifications.map((message, index) => (
                <CampaignMessageChatItem
                  key={index}
                  user={user}
                  message={message}
                  messages={messages}
                  deleteMessage={deleteMessage}
                  isAuthenticated={isAuthenticated}
                  profile={profile}
                  TimeOut={TimeOut}
                  setShowReportUser={setShowReportUser}
                  setReportedUser={setReportedUser}
                  moderators={moderators}
                  moderate={moderate}
                  deleteModerator={deleteModerator}
                  timeoutDeleteMessage={timeoutDeleteMessage}
                  banDeleteMessage={banDeleteMessage}
                  Ban={Ban}
                  notifications={notifications}
                  setNotifications={setNotifications}
                  xFalse={xFalse}
                />
              ))}
          {notifications && notifications.length <= 0 && (
            <div className="empty-side-container">
              <p className="empty-content-alt-dark-chat red bold">
                No New Notifications
              </p>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

StreamNotifications.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(StreamNotifications);
